import Config from '../config';
import { MEDIA_TYPE } from '../utils/constants/media';
import { axiosGetWithCookies, axiosPutWithCookies } from './helper';

export const MEDIA_PATH = '/media/media';
let apiBaseUrl = Config.api;
// If relative url, make it absolute url
if (apiBaseUrl.startsWith('/')) {
  apiBaseUrl = `${window.location.origin}${apiBaseUrl}`;
}
export const MEDIA_LOCATION = `${apiBaseUrl}${MEDIA_PATH}`;

export const getMediaUrl = ({ userId, mediaId, type = MEDIA_TYPE.IMAGE }) => {
  return axiosGetWithCookies(`${MEDIA_PATH}/${userId}/${mediaId}/${type}`);
};

export const uploadMediaItem = ({
  userId,
  mediaId,
  type = MEDIA_TYPE.IMAGE,
  data,
}) => {
  return axiosPutWithCookies(`${MEDIA_PATH}/${userId}/${mediaId}/${type}`, {
    data,
  });
};
